import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';

import {INewYearReports, INewYearReportsResponse, INewYearReportsRequest,INPIASMissingFields, INpiasSameSiteDiffLocid } from './new-year-rollover-reports';
import { HttpHelper } from '../../../shared/http-helper';

import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';

@Injectable()
export class NewYearReportsService {
    
    private _newYearRolloverUrl = `api/systemmanagement`;
 
    constructor(private _httpHelper: HttpHelper) { }

   /* getNewYearRolloverStep(): Observable<INewYearRolloverSteps> {
         return this._httpHelper.get(`${this._newYearRolloverUrl}`)
    }*/
    public setLocidHistory():Observable<INPIASMissingFields> {
         return this._httpHelper.get(`${this._newYearRolloverUrl}/SetHistoryList`)
    }
    public getNpiasMissingFields():Observable<INPIASMissingFields> {
         return this._httpHelper.get(`${this._newYearRolloverUrl}/NpiasMissingFieldsLocidList`)
    }
    public getNpiasDiffSite():Observable<INewYearReportsResponse> {
         return this._httpHelper.get(`${this._newYearRolloverUrl}/NpiasDiffSiteSameLocidList`)
    }
    public getNpiasSameSite():Observable<INpiasSameSiteDiffLocid> {
         return this._httpHelper.get(`${this._newYearRolloverUrl}/NpiasSameSiteDiffLocidList`)
    }

    public getNpiasToBeInserted():Observable<INewYearReportsResponse> {
         return this._httpHelper.get(`${this._newYearRolloverUrl}/NpiasToBeInsertedLocidList`)
    }
    public getNpiasToBeDeleted():Observable<INewYearReportsResponse> {
         return this._httpHelper.get(`${this._newYearRolloverUrl}/NpiasToBeDeletedLocidList`)
    }
    public deleteNpiasLocid(request:any):Observable<INewYearReportsResponse> {
         return this._httpHelper.post(`${this._newYearRolloverUrl}/NpiasDeleteLocid`, request)
    }
    public insertNpiasLocid(request:any):Observable<INewYearReportsResponse> {
         return this._httpHelper.post(`${this._newYearRolloverUrl}/NpiasInsertLocid`, request)
    }

    private handleError(error: Response) {
         // in a real world app, we may send the server to some remote logging infrastructure
         // instead of just logging it to the console
                 
         console.error(error);
         return Observable.throw(error.json().error || 'Server error');
    }
}


/** WEBPACK FOOTER **
 ** ./app/system-management/new-year-rollover/new-year-rollover-reports/new-year-rollover-reports.service.ts
 **/